import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import GridSection from "../../../V2/Layouts/GridSection"

import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"

const StoryblokGridSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.GridSection>) => {
  const itemCount = blok.content?.length || 0

  return (
    <GridSection
      id={blok.id}
      headingSize={blok.headingSize}
      alignment={blok.alignment}
      superscriptText={blok.superscriptText}
      overrideSuperscriptColor={blok.overrideSuperscriptColor}
      headingText={blok.headingText}
      overrideHeadingTextColor={blok.overrideHeadingTextColor}
      headingBodyText={blok.headingBodyText}
      overrideHeadingBodyColor={blok.overrideHeadingBodyColor}
      primaryBackgroundColor={blok.primaryBackgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      rounded={!blok.isNotRounded} //TODO write migration to make this isRounded prop + set to true for all existing gridSections
      ctaType={blok.ctaType}
      ctaText={blok.ctaText}
      ctaColor={blok.ctaColor}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      ctaLink={
        blok.ctaLink && linkIsNotNull(blok.ctaLink)
          ? getUrlFromStoryblokLink(blok.ctaLink)
          : undefined
      }
      secondaryCtaText={blok.secondaryCtaText}
      secondaryCtaLink={
        blok.secondaryCtaLink && linkIsNotNull(blok.secondaryCtaLink)
          ? getUrlFromStoryblokLink(blok.secondaryCtaLink)
          : undefined
      }
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {blok.content.map((content, index) => {
        const mobileGridOrder = blok.isMobileGridReversed
          ? itemCount - index // eg: index 2 (3rd item in an array of 3 items) will get order: 1
          : undefined // Dont set a order if we dont need it (for desktop)

        return (
          <StoryblokComponent
            key={content._uid}
            blok={content}
            mobileGridOrder={mobileGridOrder}
          />
        )
      })}
    </GridSection>
  )
}

export default StoryblokGridSection
